import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { timeRangeZodSchema } from "@@/shared/date-time/time-range";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { resourceIdZodSchema } from "../../resources/resource-id";

const blockDestioResourcesCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("BLOCK_RESOURCES_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    blockType: z.literal("DESTIO"),
    providerId: providerIdZodSchema,
    resourceIds: z.array(resourceIdZodSchema),
    timeRange: timeRangeZodSchema,
    comments: z.array(z.string()),
});
const blockExternalOrderResourcesCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("BLOCK_RESOURCES_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    resourceIds: z.array(resourceIdZodSchema),
    timeRange: timeRangeZodSchema,
    blockType: z.enum(["EXTERNAL_THIRD_PARTY_ORDER"]),
    source: z.enum(["sirvoy", "generic"]),
    externalOrderId: z.string(),
    externalResourceName: z.string(),
    importId: z.string(),
    comments: z.array(z.string()),
    description: z.string(),
});

const blockResourcesCommandZodObject = z.discriminatedUnion("blockType", [
    blockDestioResourcesCommandZodObject,
    blockExternalOrderResourcesCommandZodObject,
]);

type BlockResourcesCommand = z.infer<typeof blockResourcesCommandZodObject>;

type FactoryParams = Except<
    BlockResourcesCommand,
    "_id" | "_type" | "_createdAt"
>;

const blockResourcesCommandFactory = (params: FactoryParams) => {
    const command: BlockResourcesCommand = {
        ...params,
        _id: generateId({ prefix: "block_resources_command__" }),
        _type: "BLOCK_RESOURCES_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export { blockResourcesCommandFactory, blockResourcesCommandZodObject };
export type { BlockResourcesCommand };
